export default "/cities.e6cd9139-73259d.png";